import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import TeamListLayer from '../components/teams/TeamListLayer'
import TeamReportLayer from '../components/reports/TeamReport'

export const TeamReportPage = () => {
  return (
    <MasterLayout>
      <TeamReportLayer/>
    </MasterLayout>
  )
}
